import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import FormikFieldHelperText from '~components/field-helper-text/formik-field-helper-text';
import SelectWithActionOptions from './select-with-action-options';

const FormikSelectWithActionOptions = (props) => {
  const { fieldConfig, FieldHelperTextProps, ...others } = props;
  const [field, meta, { setValue }] = useField(fieldConfig);
  const error = meta.touched && meta.error;

  return (
    <>
      <SelectWithActionOptions {...field} onChange={setValue} error={!!error} {...others} />
      <FormikFieldHelperText {...FieldHelperTextProps} meta={meta} />
    </>
  );
};

FormikSelectWithActionOptions.propTypes = {
  fieldConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  FieldHelperTextProps: PropTypes.object,
};

export default FormikSelectWithActionOptions;
